import { Common } from '@stockbit/ui';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { effects as chatEffects } from 'lib/entities/chat/slice';

import useChatStore from 'stores/chat';
import MessageItem from './MessageItem';
import {
  DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST,
  DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST_EMPTY,
} from './__tests__/constant';

const { Text, Flex } = Common;

const MessageList = () => {
  const rooms = useChatStore((store) => store.rooms.default.list);
  const fetchRooms = useChatStore((store) => store.fetchDefaultRooms);

  const dispatch = useDispatch();

  useEffect(() => {
    if (rooms.length === 0) {
      fetchRooms({ offset: 0, limit: 25 });
    }
  }, [dispatch]);

  const markAsReadItem = (id) => () => {
    dispatch(chatEffects.readChat(id));
  };

  if (rooms.length > 0) {
    return (
      <div data-cy={DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST}>
        {rooms.map((item) => (
          <MessageItem
            key={item.id}
            item={item}
            onClick={markAsReadItem(item.id)}
          />
        ))}
      </div>
    );
  }

  return (
    <Flex
      align="center"
      justify="center"
      p="15px 0"
      data-cy={DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST_EMPTY}
    >
      <Text>No Recent Chat ...</Text>
    </Flex>
  );
};

export default MessageList;
